import React, { useState, useEffect } from "react";
import { CloseOutlined } from "@mui/icons-material";
import { ChartData } from "chart.js";
import newurl from "../../helpers/newUrl";
import { toast, ToastContainer } from "react-toastify";
import { Redirect } from "react-router";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import "react-toastify/dist/ReactToastify.css";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  Typography,
  Tooltip,
  Modal,
  Divider,
  Grid,
  IconButton,
} from "@mui/material";
import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
} from "chart.js";
import DiversionHeader from "./DiversionHeader";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

ChartJS.register(ArcElement, ChartTooltip, Legend, ChartDataLabels);

interface Material {
  type_id: number;
  type_name: string;
  total: number | string;
}

interface InventoryData {
  incomingTotal: number;
  outgoingTotal: number;
  sortedTotal: number;
  rejectTotal: number;
  adjustmentTotal: number;
  unsortedTotal: number;
  total: number;
  materials: Material[];
}

interface Adjustment {
  type_id: number;
  type_name: string;
  value: number;
}

interface InventoryProps {
  user: {
    id: number;
    name: string;
    selectedHierarchies: number[];
    selectedHierarchyIds: any[];
    email?: string;
    role?: string;
    is_active?: boolean;
  };
}

const fontSizeInTable = "1.1rem";
const fontSizeInDialog = "1rem";

const Inventory: React.FC<InventoryProps> = ({ user }) => {
  const [inventoryData, setInventoryData] = useState<InventoryData | null>(
    null
  );
  const [materials, setMaterials] = useState<Material[]>([]);
  const [openAdd, setOpenAdd] = useState<boolean>(false);
  const [openExport, setOpenExport] = useState<boolean>(false);
  const [showingOthers, setShowingOthers] = useState<boolean>(false);
  const [displayMaterials, setDisplayMaterials] = useState<Material[]>([]);
  const [dialogAdjustments, setDialogAdjustments] = useState<Adjustment[]>([]);
  const [editAmounts, setEditAmounts] = useState<string[]>([]);

  const [fromDate, setFromDate] = useState<Date | null>(null);
  const [toDate, setToDate] = useState<Date | null>(null);

  // useEffect(() => {
  //   const fetchInventory = async () => {
  //     try {
  //       const res = await newurl.get(`inventory`, {
  //         params: { hierarchies: user.selectedHierarchyIds },
  //       });
  //       const data: InventoryData = res.data;
  //       setInventoryData(data);
  //       setMaterials(data.materials || []);
  //       setDialogAdjustments(
  //         (data.materials || []).map((m) => ({
  //           type_id: m.type_id,
  //           type_name: m.type_name,
  //           value: 0,
  //         }))
  //       );
  //       setEditAmounts(new Array((data.materials || []).length).fill(""));
  //     } catch (error) {}
  //   };
  //   fetchInventory();
  // }, [user.selectedHierarchies]);
  useEffect(() => {
  const fetchInventory = async () => {
    try {
      const res = await newurl.get(`inventory`, {
        params: { hierarchies: user.selectedHierarchyIds },
      });
      const data: InventoryData = res.data;
      setInventoryData(data);
      // const allMaterials = data.materials || [];
      const allMaterials = (data.materials || []).map((m) => ({
        ...m,
        total: Number(Number(m.total).toFixed(1)),
      }))
      setMaterials(allMaterials);
      
      // Process top 8 + others
      const sorted = [...allMaterials].sort((a, b) => Number(b.total) - Number(a.total));
      const top8 = sorted.slice(0, 8);
      const others = sorted.slice(8);

      if (others.length > 0) {
        const othersTotal = others.reduce((sum, m) => sum + Number(m.total), 0);
        const displayData = [
          ...top8,
          { type_id: -1, type_name: 'Others', total: othersTotal }
        ];
        setDisplayMaterials(displayData);
      } else {
        setDisplayMaterials(top8);
      }
      
      setDialogAdjustments(
        allMaterials.map((m) => ({
          type_id: m.type_id,
          type_name: m.type_name,
          value: 0,
        }))
      );
      setEditAmounts(new Array(allMaterials.length).fill(""));
    } catch (error) {}
  };
  fetchInventory();
}, [user.selectedHierarchies]);

  const handleAddOpen = () => {
    setDialogAdjustments(
      materials.map((m) => ({
        type_id: m.type_id,
        type_name: m.type_name,
        value: 0,
      }))
    );
    setEditAmounts(new Array(materials.length).fill(""));
    setOpenAdd(true);
  };

  const handleAdjust = async () => {
    try {
      const adjustments = dialogAdjustments
        .filter((adj) => adj.value !== 0)
        .map((adj) => ({
          hierarchy_id: user.selectedHierarchyIds[0],
          sorted_waste_for_storage_type_id: adj.type_id,
          adjustment_value: Number(adj.value),
        }));
      if (adjustments.length === 0) {
        setOpenAdd(false);
        return;
      }
      await newurl.post(`inventory/adjust`, {
        hierarchies: user.selectedHierarchyIds,
        adjustments,
      });
      setOpenAdd(false);
      // const res = await newurl.get(`inventory`, {
      //   params: { hierarchies: user.selectedHierarchyIds },
      // });
      // const data: InventoryData = res.data;
      // setInventoryData(data);
      // setMaterials(data.materials || []);
      // toast.success("Adjustments successfully saved!");
      const res = await newurl.get(`inventory`, {
  params: { hierarchies: user.selectedHierarchyIds },
});
const data: InventoryData = res.data;
setInventoryData(data);
// const allMaterials = data.materials || [];
const allMaterials = (data.materials || []).map((m) => ({
  ...m,
  total: Number(Number(m.total).toFixed(1)),
}));
setMaterials(allMaterials);

// Process top 8 + others
const sorted = [...allMaterials].sort((a, b) => Number(b.total) - Number(a.total));
const top8 = sorted.slice(0, 8);
const others = sorted.slice(8);

if (others.length > 0) {
  const othersTotal = others.reduce((sum, m) => sum + Number(m.total), 0);
  const displayData = [
    ...top8,
    { type_id: -1, type_name: 'Others', total: othersTotal }
  ];
  setDisplayMaterials(displayData);
} else {
  setDisplayMaterials(top8);
}
setShowingOthers(false);

toast.success("Adjustments successfully saved!");
    } catch (error) {
        const backendMessage = (error as any)?.response?.data?.error;
        toast.error(backendMessage || 'Failed to save adjustments.');
    }
  };

  const handleEditAmountChange = (idx: number, newValue: string) => {
    if (!/^\d*$/.test(newValue) && newValue !== "") return;
    setEditAmounts(editAmounts.map((v, i) => (i === idx ? newValue : v)));
    setDialogAdjustments(
      dialogAdjustments.map((item, i) =>
        i === idx ? { ...item, value: Number(newValue) || 0 } : item
      )
    );
  };

  const applyDelta = (idx: number, sign: 1 | -1) => {
    const amt = Number(editAmounts[idx]) || 0;
    const delta = sign * amt;
    setDialogAdjustments(
      dialogAdjustments.map((item, i) =>
        i === idx ? { ...item, value: delta } : item
      )
    );
    setEditAmounts(editAmounts.map((v, i) => (i === idx ? amt.toString() : v)));
  };

  const pieData: ChartData<"pie", number[], string> = {
    labels: displayMaterials.map((adj) => adj.type_name),
    datasets: [
      {
        label: "Weight (Kgs)",
        data: displayMaterials.map((adj) => Number(adj.total)),
        backgroundColor: (() => {
          const count = materials.length;
          const colors: string[] = [];
          const hueStep = 360 / count;
          for (let i = 0; i < count; i++) {
            colors.push(`hsl(${i * hueStep}, 70%, 50%)`);
          }
          return colors;
        })(),
        borderColor: "#fff",
        borderWidth: 1,
      },
    ],
  };

  // const pieOptions = {
  //   responsive: true,
  //   plugins: {
  const pieOptions = {
  responsive: true,
  onClick: (event: any, elements: any) => {
    if (elements.length > 0) {
      const index = elements[0].index;
      const clickedMaterial = displayMaterials[index];
      if (clickedMaterial.type_id === -1 && !showingOthers) {
        // Show others breakdown
        const sorted = [...materials].sort((a, b) => Number(b.total) - Number(a.total));
        const others = sorted.slice(8);
        setDisplayMaterials(others);
        setShowingOthers(true);
      }
    }
  },
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      enabled: true,
      callbacks: {
        label: function (context: any) {
          const label = context.label || "";
          const value = context.parsed || 0;
          const dataset = context.dataset;
          const total = dataset.data.reduce(
            (acc: number, val: number) => acc + val,
            0
          );
          const percentage = total ? ((value / total) * 100).toFixed(1) : "0";
          return `${label}: ${Number(value).toFixed(1)} Kgs (${percentage}%)`;
        },
      },
      bodyFont: {
        size: 14,
        weight: "bold",
      },
      titleFont: {
        size: 16,
        weight: "bold",
      },
    },
    datalabels: {
      color: '#fff',
      font: {
        weight: 'bold' as const,
        size: 14,
      },
      formatter: (value: number, context: any) => {
        const dataset = context.chart.data.datasets[0];
        const total = dataset.data.reduce((acc: number, val: number) => acc + val, 0);
        const percentage = total ? ((value / total) * 100).toFixed(1) : "0";
        // const label = context.chart.data.labels[context.dataIndex];
        // return `${label}\n${percentage}%`;
        return `${percentage}%`;
      },
    },
  },
  layout: {
    padding: {
      bottom: 40,
    },
  },
};
const allowedEmails =
  process.env.REACT_APP_INVENTORY_ALLOWED_EMAIL?.split(",") || [];

if (!user?.email || !allowedEmails.includes(user.email)) {
  return <Redirect to="/login" />;
}
  return (
    <Box sx={{ width: "100%" }}>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        closeOnClick
      />
     <DiversionHeader
      user={{
        ...user,
        email: user.email ?? "",
        role: user.role ?? "",
        is_active: user.is_active ?? false,
      }}
    />
      <Box
        sx={{
          maxWidth: 1200,
          mx: "auto",
          background: "#fff",
          borderRadius: 3,
          boxShadow: 3,
          p: { xs: 2, md: 4 },
          mt: 4,
        }}
      >
        <Box
          sx={{
            mb: 3,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontWeight: 700,
              fontSize: fontSizeInTable,
              userSelect: "none",
            }}
          >
            Inventory{" "}
            <Box component="span" sx={{ fontSize: "0.8rem" }}>
              (
            </Box>
            <Tooltip
              title="Sorted - Outgoing - Reject"
              placement="right"
              arrow
              slotProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "white",
                    color: "darkgreen",
                    fontSize: "0.875rem",
                    border: "1px solid darkgreen",
                  },
                },
                arrow: { sx: { color: "white" } },
              }}
            >
              <Box
                component="span"
                sx={{
                  textDecoration: "underline",
                  cursor: "pointer",
                  fontSize: "0.8rem",
                  fontWeight: 600,
                }}
              >
                i
              </Box>
            </Tooltip>
            <Box component="span" sx={{ fontSize: "0.8rem" }}>
              )
            </Box>
          </Typography>
          <Box sx={{ display: "flex", gap: 2 }}>
            <Button
              variant="contained"
              sx={{ backgroundColor: "#204d36", fontWeight: 600, boxShadow: 1 }}
              onClick={handleAddOpen}
            >
              ADJUSTMENTS
            </Button>
            <Button
              variant="contained"
              sx={{ backgroundColor: "#204d36", fontWeight: 600, boxShadow: 1 }}
              onClick={() => {
                setFromDate(null);
                setToDate(null);
                setOpenExport(true);
              }}
            >
              EXPORT ADJUSTMENTS
            </Button>
          </Box>
        </Box>
        <Box
          sx={{
            display: { xs: "block", md: "flex" },
            gap: 4,
            alignItems: "flex-start",
          }}
        >
          <TableContainer component={Paper} sx={{ flex: 1, boxShadow: 1 }}>
            <Table>
              <TableHead>
                <TableRow sx={{ background: "#274226" }}>
                  <TableCell
                    align="center"
                    sx={{
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: fontSizeInTable,
                    }}
                  >
                    Material Type
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: fontSizeInTable,
                    }}
                  >
                    Weight (Kgs)
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {inventoryData && (
                  <>
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{ fontWeight: "bold", fontSize: fontSizeInTable }}
                      >
                        Total
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ fontWeight: "bold", fontSize: fontSizeInTable }}
                      >
                        {inventoryData.total}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{ fontWeight: "bold", fontSize: fontSizeInTable }}
                      >
                        Unsorted Total
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ fontWeight: "bold", fontSize: fontSizeInTable }}
                      >
                        {inventoryData.unsortedTotal}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        align="center"
                        sx={{ fontWeight: "bold", fontSize: fontSizeInTable }}
                      >
                        Sorted Total
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{ fontWeight: "bold", fontSize: fontSizeInTable }}
                      >
                        {inventoryData.sortedTotal}
                      </TableCell>
                    </TableRow>
                  </>
                )}
                {materials.map((mat) => (
                  <TableRow key={mat.type_id}>
                    <TableCell
                      align="center"
                      sx={{ fontSize: fontSizeInTable }}
                    >
                      {mat.type_name}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ fontSize: fontSizeInTable }}
                    >
                      {Number(mat.total).toFixed(1)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box
            sx={{
              flex: 1,
              minWidth: 320,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "flex-end",
              height: "100%",
            }}
          >
            <Box
              sx={{
                width: 450,
                height: 450,
                display: "flex",
                alignItems: "flex-end",
                mb: 0,
              }}
            >
              <Pie
                data={pieData}
                options={pieOptions}
                width={450}
                height={450}
              />
            </Box>
            {/* <Grid container spacing={1} sx={{ width: "100%", mt: 3 }}>
              {materials.map((mat, idx) => ( */}
              {showingOthers && (
              <Button
                variant="contained"
                sx={{ 
                  backgroundColor: "#204d36", 
                  fontWeight: 600, 
                  mt: 2
                }}
                onClick={() => {
                  const sorted = [...materials].sort((a, b) => Number(b.total) - Number(a.total));
                  const top8 = sorted.slice(0, 8);
                  const others = sorted.slice(8);
                  if (others.length > 0) {
                    const othersTotal = Number(others.reduce((sum, m) => sum + Number(m.total), 0).toFixed(1));
                    setDisplayMaterials([...top8, { type_id: -1, type_name: 'Others', total: othersTotal }]);
                  } else {
                    setDisplayMaterials(top8);
                  }
                  setShowingOthers(false);
                }}
              >
                ← Back to Top 8
              </Button>
            )}
            <Grid container spacing={1} sx={{ width: "100%", mt: 3 }}>
              {displayMaterials.map((mat, idx) => (
                <Grid item xs={12} sm={6} md={4} key={mat.type_id}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Box
                      sx={{
                        width: 16,
                        height: 16,
                        borderRadius: "50%",
                        background: (
                          pieData.datasets[0].backgroundColor as string[]
                        )[idx],
                      }}
                    />
                    <Typography variant="body2">{mat.type_name}</Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Box>
      </Box>
      {/* Dialogs and Modals unchanged from original */}
      <Dialog
        open={openAdd}
        onClose={() => setOpenAdd(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <Typography sx={{ fontSize: fontSizeInDialog, fontWeight: 700 }}>
            Add Adjustments
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "column" },
              gap: 4,
              justifyContent: "center",
              alignItems: "flex-start",
            }}
          >
            <Table size="small" sx={{ minWidth: 360 }}>
              <TableHead>
                <TableRow sx={{ background: "#274226" }}>
                  <TableCell
                    align="center"
                    sx={{
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: fontSizeInDialog,
                    }}
                  >
                    Material Type
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: fontSizeInDialog,
                    }}
                  >
                    Weight Adjustment
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      color: "#fff",
                      fontWeight: "bold",
                      fontSize: fontSizeInDialog,
                    }}
                  >
                    Controls
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dialogAdjustments.map((row, idx) => (
                  <TableRow key={row.type_id}>
                    <TableCell
                      align="center"
                      sx={{ fontSize: fontSizeInDialog }}
                    >
                      {row.type_name}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ fontSize: fontSizeInDialog }}
                    >
                      {row.value}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        fontSize: fontSizeInDialog,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 1,
                      }}
                    >
                      <Button
                        variant="outlined"
                        size="small"
                        sx={{ minWidth: 30, fontSize: "1rem" }}
                        onClick={() => applyDelta(idx, -1)}
                      >
                        -
                      </Button>
                      <TextField
                        value={editAmounts[idx]}
                        onChange={(e) =>
                          handleEditAmountChange(idx, e.target.value)
                        }
                        size="small"
                        type="number"
                        inputProps={{
                          min: 0,
                          style: { textAlign: "center", width: "60px" },
                        }}
                        placeholder=""
                      />
                      <Button
                        variant="outlined"
                        size="small"
                        sx={{ minWidth: 30, fontSize: "1rem" }}
                        onClick={() => applyDelta(idx, 1)}
                      >
                        +
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            sx={{ bgcolor: "#204d36" }}
            onClick={handleAdjust}
          >
            Adjust
          </Button>
        </DialogActions>
      </Dialog>
      <Modal
        open={openExport}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "65%",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              mb: 2,
            }}
          >
            <Typography variant="h6" component="div" className="text-left">
              Export Data
            </Typography>
            <IconButton
              color="primary"
              className="customIconButton"
              aria-label="close"
              component="span"
              onClick={() => setOpenExport(false)}
            >
              <CloseOutlined />
            </IconButton>
          </Box>
          <Divider className="mb-3" />
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="yyyy-MM-dd"
                  views={["year", "month", "day"]}
                  label="From Date *"
                  renderInput={(props) => <TextField {...props} fullWidth />}
                  value={fromDate}
                  onChange={(newValue) => setFromDate(newValue)}
                  minDate={new Date(2025, 3, 1)}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={6}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="yyyy-MM-dd"
                  views={["year", "month", "day"]}
                  label="To Date *"
                  renderInput={(props) => <TextField {...props} fullWidth />}
                  value={toDate}
                  onChange={(newValue) => setToDate(newValue)}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
          <Divider className="mt-3" />
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", mt: 2, gap: 1 }}
          >
            <Button
              size="small"
              className="customCloseButton"
              onClick={() => setOpenExport(false)}
            >
              Close
            </Button>
            <Button
              size="small"
              variant="contained"
              sx={{ outline: "none !important", bgcolor: "#204d36" }}
              disabled={!fromDate || !toDate}
              onClick={async () => {
                if (!fromDate || !toDate) return;
                try {
                  const hierarchyId = user.selectedHierarchyIds[0];
                  const response = await newurl.get(`inventory/export`, {
                    params: {
                      hierarchy_id: hierarchyId,
                      from: fromDate
                        ? new Date(fromDate.getTime() + 86400000)
                            .toISOString()
                            .slice(0, 10)
                        : "",
                      to: toDate
                        ? new Date(toDate.getTime() + 86400000)
                            .toISOString()
                            .slice(0, 10)
                        : "",
                    },
                    responseType: "blob",
                  });

                  // Trigger CSV download
                  const url = window.URL.createObjectURL(response.data);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = "inventory_adjustments.csv";
                  document.body.appendChild(a);
                  a.click();
                  a.remove();
                  window.URL.revokeObjectURL(url);

                  setOpenExport(false);
                } catch (error) {
                  alert("Failed to export inventory adjustments");
                  console.error(error);
                }
              }}
            >
              Download
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default Inventory;
